import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './components/layout/theme';
import LandingPage from './pages/lps-form/Landing-page';
const router = createBrowserRouter([
  {
    path: "/:form_name",
    element: <LandingPage />
  }
],{ basename: "/lps" });

export default function AppRoutes() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}
